import { useState, useEffect, useMemo, useRef } from 'react';
import CardLayout from '../../../components/utils/CardLayout';
import { useDispatch, useSelector } from 'react-redux';
import portinActivationAction from '../../../redux/portinActivation/actions'
import Button from '../../../components/utils/Button'
import Table from '../../../components/utils/Table';
import SideButtons from '../../../components/utils/SideButtons';
import Alert from '../../../components/utils/Alert';
import SearchBar from '../../../components/utils/SearchBar';
import { convertDateTimeToRequiredFormatTZ, isAdmin, isAdminAgent, isDealer, isAdminOrAgent } from '../../../helpers/commonFunction';
import Tag from '../../../components/utils/Tag'
import DownloadCloud2sLineIcon from 'remixicon-react/DownloadCloud2LineIcon';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
import Modal from '../../../components/utils/Model'
import EyeFill from 'remixicon-react/EyeFillIcon';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AddPortinActivation from './AddPortinActivation';
import authActions from '../../../redux/auth/actions';
import EditCircleLineIcon from 'remixicon-react/EditCircleLineIcon';
import ManualPortinUpdate from './ManualPortinUpdate';
import DataTable from '../../../components/utils/DataTableClient';
import InCompletePortinCount from './InCompletePortinCount';
import moment from "moment";
import dealerAction from '../../../redux/dealer/actions'
import DatePicker from "react-datepicker";
import { useForm } from 'react-hook-form';
import Calendar2LineIcon from 'remixicon-react/Calendar2LineIcon';
import CompletePortinActivation from './CompletePortinActivation';
import CancelPortinActivation from './CancelPortinActivation';
import useSocket from '../../../hooks/useSocket';
import SocketActions from '../../../redux/socket/actions'
import PortinActivationRefund from './PortinActivationRefund';

const { getBulkPortinActivationListByBatchID, openAddPortinModal, updatePortinStatus, resetMessage, resetSucessMessage, getBulkPortinActivation, lockPortinActivation, unlockPortinActivation } = portinActivationAction;
const { getUserDataByToken } = authActions;
const { getDealer } = dealerAction;
const { getLockedPortinnRequestForSocket } = SocketActions;

const PortinActivation = () => {
  const dispatch = useDispatch();
  const { bulkPortinActivationList, bulkPortinActivationLoading, bulkPortinActivationResultByBatchID, bulkPortinActivationResultByBatchIDLoading, createPortinActivationMessage, updatePortinStatusMessage, updatePortinStatusError, updateManualPortinActivationMessage, searchButtonLoading, lockPortinActivationError, lockPortinActivationMessage, unlockPortinActivationError, unlockPortinActivationMessage, cancelPortActivationMessage, completePortinActivationMessage, refundPortActivationMessage } = useSelector((state) => state.portinActivation);
  const dealerResult = useSelector((state) => state.dealer.dealerResult);
  const { tokenData } = useSelector((state) => state.auth);
  const [filterText, setFilterText] = useState("");
  const [openViewModel, setOpenViewModel] = useState(false);
  const [selectedBatchID, setSelectedBatchID] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [alertText, setAlertText] = useState('');
  const [selectedBatchData, setSelectedBatchData] = useState(null);
  const [manualUpdateFlag, setManualUpdateFlag] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [bulkTxnRow, setBulkTxnRow] = useState({});
  const [completeModal, setCompleteModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  const [toDate, setToDate] = useState(new Date())
  const [fromDate, setFromDate] = useState(new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000));
  const [searchButtonData, setSearchButtonData] = useState({
    statusID: '0',
    fromDate: moment(fromDate).format("YYYY-MM-DD"),
    toDate: moment(toDate).format("YYYY-MM-DD"),
    dealerID: "",
  });
  const { register: registerFilter, handleSubmit: handleSearch, formState: { errors: filterError } } = useForm({ defaultValues: searchButtonData });
  const [appliedSearch, setAppliedSearch] = useState(searchButtonData);
  const datePickerRef = useRef(null);
  const datePickerRef2 = useRef(null);
  const [refundModal, setRefundModal] = useState(false);

  const openDatePicker = () => {
    datePickerRef.current.setOpen(true);
  };

  const openDatePicker2 = () => {
    datePickerRef2.current.setOpen(true);
  };

  useSocket('lock activation request', () => {
    if (isAdmin(tokenData) || isAdminAgent(tokenData)) {
      if (!selectedBatchID) return;
      const newData = {
        batchID: selectedBatchID
      };
      dispatch(getLockedPortinnRequestForSocket(newData));
    }
  });

  useEffect(() => {
    dispatch(getBulkPortinActivation(searchButtonData));
    dispatch(getDealer());
    dispatch(resetSucessMessage())
  }, []);

  useEffect(() => {
    if (createPortinActivationMessage !== null && createPortinActivationMessage !== undefined) {
      displayAlert(createPortinActivationMessage, 'alert-success');
      dispatch(resetMessage());
      dispatch(getUserDataByToken());
    }
    if (updatePortinStatusError !== null && updatePortinStatusError !== undefined) {
      displayAlert(updatePortinStatusError, 'alert-danger');
      dispatch(getUserDataByToken());
    }
    if (updatePortinStatusMessage !== null && updatePortinStatusMessage !== undefined) {
      displayAlert(updatePortinStatusMessage, 'alert-success');
      dispatch(getUserDataByToken());
    }
    if (updateManualPortinActivationMessage !== null && updateManualPortinActivationMessage !== undefined) {
      displayAlert(updateManualPortinActivationMessage, 'alert-success');
      setManualUpdateFlag(false);
      dispatch(resetSucessMessage())
      dispatch(getUserDataByToken());
    }

    if (lockPortinActivationError !== null && lockPortinActivationError !== undefined) {
      // displayAlert(lockPortinActivationError, 'alert-danger');
      toast.error(lockPortinActivationError, { autoClose: 2000 });
    }
    if (lockPortinActivationMessage !== null && lockPortinActivationMessage !== undefined) {
      // displayAlert(lockPortinActivationMessage, 'alert-success');
      toast.success(lockPortinActivationMessage, { autoClose: 2000 });
    }

    if (unlockPortinActivationError !== null && unlockPortinActivationError !== undefined) {
      toast.error(unlockPortinActivationError, { autoClose: 2000 });
      // displayAlert(unlockPortinActivationError, 'alert-danger');
    }
    if (unlockPortinActivationMessage !== null && unlockPortinActivationMessage !== undefined) {
      // displayAlert(unlockPortinActivationMessage, 'alert-success');
      toast.success(unlockPortinActivationMessage, { autoClose: 2000 });
    }

    if (cancelPortActivationMessage !== null && cancelPortActivationMessage !== undefined) {
      // displayAlert(cancelPortActivationMessage, 'alert-success');
      toast.success(cancelPortActivationMessage, { autoClose: 2000 });
      alertCancel();
      dispatch(getUserDataByToken());
    }

    if (completePortinActivationMessage !== null && completePortinActivationMessage !== undefined) {
      // displayAlert(completePortinActivationMessage, 'alert-success');
      toast.success(completePortinActivationMessage, { autoClose: 2000 });
      alertCancel();
    }

    if (refundPortActivationMessage !== null && refundPortActivationMessage !== undefined) {
      // displayAlert(cancelPortActivationMessage, 'alert-success');
      toast.success(refundPortActivationMessage, { autoClose: 2000 });
      alertCancel();
      dispatch(getUserDataByToken());
    }
  }, [
    createPortinActivationMessage,
    updatePortinStatusError,
    updatePortinStatusMessage,
    updateManualPortinActivationMessage,
    lockPortinActivationError,
    lockPortinActivationMessage,
    unlockPortinActivationError,
    unlockPortinActivationMessage,
    cancelPortActivationMessage,
    completePortinActivationMessage,
    refundPortActivationMessage
  ]);

  const handleFilterChange = (value) => {
    setFilterText(value);
  };

  const handleShowTransactionDetails = (item) => {
    alertCancel();
    setOpenViewModel(true);
    const batchID = item.bulktransactionid;
    setSelectedBatchID(batchID);
    const newData = {
      batchID: batchID,
    };
    setSelectedBatchData(newData)
    dispatch(getBulkPortinActivationListByBatchID(newData));
  };

  const handleSearchData = (data) => {
    const newData = {
      ...data,
      toDate: moment(new Date(toDate)).format("YYYY-MM-DD"),
      fromDate: moment(new Date(fromDate)).format("YYYY-MM-DD"),
    };
    setAppliedSearch(newData);
    dispatch(getBulkPortinActivation(newData));
  }

  const handleLockActivation = (item) => {
    const lockActivationData = {
      activationId: item.ID,
    }
    const batchSearchData = {
      batchID: item.BulkTransactionID,
    };
    dispatch(lockPortinActivation(lockActivationData, batchSearchData));
  }

  const handleUnLockActivation = (item) => {
    const unLockData = {
      activationId: item.ID,
    }
    const batchSearchData = {
      batchID: item.BulkTransactionID,
    };
    dispatch(unlockPortinActivation(unLockData, batchSearchData));
  }

  //Modal Column
  const ModalColumns = [
    { displayName: '#', key: 'key' },
    { displayName: 'ACTION', key: 'action' },
    { displayName: 'TRANSACTIONID', key: 'transactionID' },
    { displayName: 'SERIAL NUMBER', key: 'serialNumber' },
    // { displayName: 'IMEI', key: 'imeiNumber' },
    ...(bulkPortinActivationResultByBatchID?.some(x => x.NetworkID == 10)
      ? [{ displayName: 'IMEI', key: 'imeiNumber' }]
      : []
    ),
    { displayName: 'PHONE NUMBER', key: 'mobileNumber' },
    { displayName: 'PIN', key: 'pin' },
    { displayName: 'ACCOUNT NUMBER', key: 'accountNumber' },
    { displayName: 'AREA CODE', key: 'zipCode' },
    { displayName: 'NETWORK', key: 'networkName' },
    { displayName: 'AMOUNT', key: 'amountCharged' },
    { displayName: 'DEALER NAME', key: 'dealerName' },
    { displayName: 'STATUS', key: 'status' },
    { displayName: 'SUBMITTED DATE', key: 'requestedDtTm' },
    ...(isAdminOrAgent(tokenData) ? [{ displayName: 'REMARK', key: 'remark' }] : []),
  ];

  //Model Data
  const dataSource = bulkPortinActivationResultByBatchID && bulkPortinActivationResultByBatchID.length > 0 && bulkPortinActivationResultByBatchID.map((Item, key) => ({
    key: key + 1,
    transactionID: Item.TransactionID,
    serialNumber: Item.SerialNumber,
    accountNumber: Item.AccountNumber,
    mobileNumber: Item.MSISDN,
    zipCode: Item.AreaCode,
    pin: Item.PIN,
    networkName: Item.NetworkName,
    dealerName: Item.DealerName,
    amountCharged: Item.AmountCharged ? '$' + parseFloat(Item.AmountCharged).toFixed(2) : '',
    requestedDtTm: Item.RequestedDtTm !== null ? convertDateTimeToRequiredFormatTZ(Item.RequestedDtTm) : '',
    status: <Tag color={Item.RequestStatus === 13 ? 'badge-danger' : Item.RequestStatus === 11 ? 'badge-warning' : Item.RequestStatus === 12 ? (Item.IsManuallyCompleted === 1 ? 'badge-dark-success' : 'badge-success') : Item.RequestStatus === 32 ? 'badge-secondary' : Item.RequestStatus === 49 ? 'badge-info' : 'badge-secondary'} title={Item.StatusDescription} />,
    // status: <Tag color={Item.RequestStatus === 13 ? 'badge-danger' : Item.RequestStatus === 11 ? 'badge-warning' : Item.RequestStatus === 12 ? 'badge-success' : Item.RequestStatus === 32 ? 'badge-secondary' : Item.RequestStatus === 49 ? 'badge-info' : 'badge-secondary'} title={Item.StatusDescription} />,
    remark: Item.Remark,
    imeiNumber: Item.IMEI,
    action: (
      <>
        {/* {Item.CustomerSupport === 0 && Item.RequestStatus == 11 ? (Item.updateLoading ? (
          <div className="spinner-border spinner-border-sm text-secondary" role="status"> <span className="sr-only">Loading...</span> </div>
        ) : (
          <div className="icon iq-action-icon-box rounded-circle bg-info" onClick={() => handleOpenStatusModal(Item.ID, Item.SerialNumber, Item.AggregatorID)} style={{ cursor: 'pointer' }}>
            <i className="ri-refresh-line"></i>
          </div>
        )
        ) : null} */}

        {/* It is only if txn is in Upload CSV Status and user is admin/agent */}
        {
          isAdminOrAgent(tokenData) && Item.RequestStatus == 49 && Item.IsManuallyCompleted == 0 && <>
            {
              Item.otherLockFlag === 0 && (
                <>
                  {
                    Item.lockLoading ?
                      <div className="spinner-border spinner-border-sm text-secondary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div> :
                      Item.lockFlag === 0 &&
                      <div className="icon iq-action-icon-box rounded-circle" style={{ backgroundColor: "purple" }} >
                        <span onClick={() => handleLockActivation(Item)}>
                          <i className="ri-lock-line" style={{ color: "#fff" }}></i>
                        </span>
                      </div>
                  }
                  {
                    Item.unlockLoading ?
                      <div className="spinner-border spinner-border-sm text-secondary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div> :
                      Item.lockFlag === 1 &&
                      <div className='d-flex'>
                        <div className="icon iq-action-icon-box rounded-circle bg-success" onClick={() => openCompleteModal(Item)}>
                          <i className="ri-check-line"></i>
                        </div>
                        <div className="icon iq-action-icon-box rounded-circle bg-danger" onClick={() => openCancelModal(Item)}>
                          <i className="ri-close-fill"></i>
                        </div>
                        <div className="icon iq-action-icon-box rounded-circle bg-secondary" onClick={() => handleUnLockActivation(Item)}>
                          <i className="ri-lock-unlock-line" style={{ color: '#fff' }}></i>
                        </div>
                      </div>
                  }
                </>
              )
            }

            {
              Item.otherLockFlag === 1 && <>
                <div className="icon iq-action-icon-box rounded-circle bg-danger" onClick={() => setShowPopup(true)} style={{ cursor: "pointer" }} >
                  <i className="ri-forbid-line"></i>
                </div>

                {/* Popup Modal */}
                {showPopup && (
                  <div style={overlayStyle}>
                    <div style={modalStyle}>
                      <h4>This transaction is locked by {Item.LockedByName}</h4>
                      <button onClick={() => setShowPopup(false)} style={buttonStyle}> Close </button>
                    </div>
                  </div>
                )}
              </>
            }
          </>
        }
        
        {/*this is for manually cancelled txn for Refund */}
        {
          isAdminOrAgent(tokenData) && Item.RequestStatus == 13 && Item.ShowRefundIcon == 1 && Item.IsManuallyCompleted == 1 && (
            <div className="icon iq-action-icon-box rounded-circle" style={{ backgroundColor: '#990404' }} >
              <span data-toggle="tooltip" data-placement="top" title="Move to Upload CSV" onClick={() => openRefundModal(Item)}>
                <i className="ri-anticlockwise-line" style={{ color: '#fff' }} ></i>
              </span> 
            </div>
          )
        }

      </>
    )
  }));

  const closeBulkTxnModal = () => {
    setOpenViewModel(false);
    alertCancel();
  }

  const listDataModel = bulkPortinActivationResultByBatchID.map((item, key) => ({
    'Sr. No': key + 1,
    'Transaction ID': item.TransactionID,
    'Serial Number': item.SerialNumber,
    'IMEI': item.IMEI,
    'Account Number': item.AccountNumber,
    'Phone Number': item.MSISDN,
    'Area Code': item.AreaCode,
    'PIN': item.PIN,
    'Network': item.NetworkName,
    'Amount': item.AmountCharged,
    'Dealer Name': item.DealerName,
    'Submitted Date': convertDateTimeToRequiredFormatTZ(item.RequestedDtTm),
    'Status': item.StatusDescription,
    'Remark': item.Remark,
  }));

  const exportToCSVModal = async () => {
    if (listDataModel && listDataModel.length > 0) {
      const ws = XLSX.utils.json_to_sheet(listDataModel);
      const wb = { Sheets: { 'bulkPortinActivationList': ws }, SheetNames: ['bulkPortinActivationList'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: fileType });
      await FileSaver.saveAs(data, 'Portin_Activation_Report' + fileExtension);
    }
  }

  const handleCopy = () => {
    const data = bulkPortinActivationResultByBatchID || [];
    if (data.length === 0) {
      toast.error('No data to copy!');
      return;
    }

    const header = ['Phone Number', 'Account Number', 'PIN', 'Area Code'];

    const rows = data.map(item => [
      item.MSISDN?.toString().trim() || '',
      item.AccountNumber?.toString().trim() || '',
      item.PIN?.toString().trim() || '',
      item.AreaCode?.toString().trim() || ''
    ]);

    const allRows = [header, ...rows];

    const colWidths = allRows[0].map((_, colIndex) =>
      Math.max(...allRows.map(row => row[colIndex].length))
    );

    const textToCopy = allRows
      .map(row => row.map((cell, i) => cell.padEnd(colWidths[i], ' ')).join('   '))
      .join('\n');

    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        toast.success('Number details copied to Clipboard', {
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch(err => {
        toast.error('Failed to copy!');
        console.error('Failed to copy: ', err);
      });
  };

  const handleRefersh = () => {
    if (!selectedBatchID) return;
    const newData = {
      batchID: selectedBatchID,
    };
    dispatch(getBulkPortinActivationListByBatchID(newData));
    toast.success('Data refreshed successfully', {
      autoClose: 2000,
    });
  }

  const handleAddPortinActivation = () => {
    dispatch(openAddPortinModal())
  }

  const displayAlert = (text, type) => {
    setAlertText(text);
    setAlertType(type);
    setShowAlert(true);
  };

  const alertCancel = () => {
    setShowAlert(false);
    setAlertText('');
    setAlertType('');
    dispatch(resetMessage());
    dispatch(resetSucessMessage())
  }

  const handleOpenStatusModal = (activationId, serialNumber, aggregatorID) => {
    let req = {
      activationId: activationId,
      serialNumber: serialNumber,
      aggregatorID: aggregatorID,
    };
    dispatch(updatePortinStatus(req, selectedBatchData));
  }

  const handleManualUpdatePortin = () => {
    setManualUpdateFlag(true);
    alertCancel();
  }

  const renderManualPortinUpdate = () => {
    return <ManualPortinUpdate show={manualUpdateFlag} hide={() => setManualUpdateFlag(false)} search={appliedSearch} />;
  }

  const columns = [
    {
      name: "#",
      selector: row => row.id,
      sortable: true,
      width: "80px",
      center: true,
    },
    {
      name: "REFERENCE",
      cell: (row) => (
        <div className="flex flex-col py-2">
          <div>
            <strong>Batch TXNID:</strong>{" "}
            <span
              onClick={() => handleShowTransactionDetails(row)}
              style={{ cursor: "pointer", color: "#990404", fontWeight: 600, textDecoration: "underline", }}
              title="view details"
            >
              {row.bulktransactionid || "-"}
            </span>
          </div>
          <div className="my-2">
            <strong>Dealer Name:</strong> {row.dealername || "-"}
          </div>
          <div>
            <strong>Dealer Email:</strong> {row.contactemailid || "-"}
          </div>
        </div>
      ),
      width: "300px",
    },
    {
      name: "NETWORK",
      selector: row => row.network,
      width: "150px",
    },
    {
      name: "AREA CODE",
      selector: row => row.areacode,
      width: "120px",
    },
    {
      name: "QUANTITY",
      cell: (row) => (
        <div style={{ display: "flex", gap: "6px" }}>
          <Tag color="badge-success" title={row.totalprocessed} />
          <Tag color="badge-danger" title={row.totalcancelled} />
          <Tag color="badge-secondary" title={row.quantity} />
        </div>
      ),
      width: "140px",
    },
    {
      name: "AMOUNT",
      selector: row => row.amount,
    },
    {
      name: "STATUS",
      cell: (row) => {
        switch (row.status) {
          case "Completed":
            return <Tag color="badge-success" title="Completed" />;
          case "Failed":
            return <Tag color="badge-danger" title="Failed" />;
          case "Partial":
          default:
            return <Tag color="badge-secondary" title="Partial" />;
        }
      },
    },
    {
      name: "SUBMITTED DATE",
      selector: row => row.submitteddate,
      width: "180px",
    },
    {
      name: "SOURCE",
      selector: row => row.source,
      width: "180px",
    },
    // {
    //   name: "ACTION",
    //   selector: row => row.action,
    //   cell: (row) => (
    //     <Link to="#" onClick={() => handleShowTransactionDetails(row)} >
    //       <span title="View">
    //         <EyeFill size="1.2em" style={{ color: "#294c28eb" }} />
    //       </span>
    //     </Link>
    //   )
    // },
  ];

  const filteredItems = Array.isArray(bulkPortinActivationList) && bulkPortinActivationList.length > 0 ? bulkPortinActivationList.filter(item => {
    if (typeof filterText !== 'string' || typeof item !== 'object') return false;
    // Check if any value in the object contains the filterText
    return Object.values(item).some(value => typeof value === 'string' && value.toLowerCase().includes(filterText.toLowerCase()));
  }) : [];

  const data = Array.isArray(filteredItems) ? filteredItems.map((item, index) => ({
    id: index + 1,
    bulktransactionid: item.BulkTransactionID,
    dealername: item.DealerName,
    contactemailid: item.ContactEmailID,
    network: item.NetworkName,
    areacode: item.AreaCode,
    totalprocessed: item.TotalSuccessTxn || 0,
    totalcancelled: item.TotalFailedTxn || 0,
    quantity: item.TotalTxn || 0,
    amount: item.TotalChargeAmt ? '$' + parseFloat(item.TotalChargeAmt).toFixed(2) : '',
    submitteddate: item.RequestedDtTm !== null ? convertDateTimeToRequiredFormatTZ(item.RequestedDtTm) : '',
    status: item.Status,
    source: item.Source == 1 ? 'Portal' : 'API',
  }))
    : [];

  // PORTIN COMPLETE MODAL
  const renderCompleteModal = () => {
    return <CompletePortinActivation modal={completeModal} row={bulkTxnRow} close={closeCompleteModal} search={appliedSearch} />;
  }

  const openCompleteModal = (row) => {
    setBulkTxnRow(row);
    setCompleteModal(true);
  }

  const closeCompleteModal = () => {
    setCompleteModal(false);
  }

  // PORTIN cancel MODAL
  const renderCancelModal = () => {
    return <CancelPortinActivation modal={cancelModal} row={bulkTxnRow} close={closeCancelModal} search={appliedSearch} />;
  }

  const openCancelModal = (row) => {
    setBulkTxnRow(row);
    setCancelModal(true);
  }

  const closeCancelModal = () => {
    setCancelModal(false);
  }

  // PORTIN REFUND MODAL
  const renderRefundModal = () => {
    return <PortinActivationRefund modal={refundModal} row={bulkTxnRow} close={closeRefundModal} search={appliedSearch} />;
  }
  const openRefundModal = (row) => {
    setBulkTxnRow(row);
    setRefundModal(true)
  }

  const closeRefundModal = () => {
    setRefundModal(false);
    dispatch(resetSucessMessage())
  }

  return (
    <CardLayout title="Portin Activation">
      <ToastContainer />
      {showAlert && !updatePortinStatusMessage && !updatePortinStatusError && <div className='mt-4'><Alert type={alertType} text={alertText} closeBtn={alertCancel} /></div>}
      {
        !manualUpdateFlag &&
        <div>
          <form onSubmit={handleSearch(handleSearchData)}>
            <div className="form-row">

              <div className="col-lg-2 col-md-4 mb-2">
                <label>Select Status</label>
                <select className="form-control" id="statusID" name="statusID" {...registerFilter("statusID")} >
                  <option value="0" name="All">All</option>
                  <option value="1" name="All">Completed</option>
                  <option value="2" name="All">Failed</option>
                  <option value="3" name="All">Partial</option>
                </select>
              </div>

              {
                (isAdmin(tokenData) || isAdminAgent(tokenData)) &&
                <div className="col-lg-2 col-md-4  mb-2">
                  <label>Select Dealer</label>
                  <select className="form-control" id="dealerID" name="dealerID"  {...registerFilter("dealerID", {
                  })} >
                    <option value="" name="All">All</option>
                    {
                      dealerResult && dealerResult.length && dealerResult.map((item) => {
                        return <option value={item.ID} key={`dealer${item.ID}`}>{item.DealerName}</option>
                      })
                    }
                  </select>
                </div>
              }

              <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                <label>From Date</label>
                <Calendar2LineIcon onClick={openDatePicker} size={'1.5rem'} style={{ cursor: 'pointer', position: 'absolute', 'top': '36px', right: '12px', zIndex: 1 }} />
                <DatePicker
                  ref={datePickerRef}
                  selected={fromDate}
                  className="form-control"
                  onChange={(date) => setFromDate(date)}
                  dateFormat="yyyy-MM-dd"
                  name="fromDate"
                  showMonthDropdown
                  showYearDropdown
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                  value={fromDate}
                />
              </div>

              <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                <label>To Date</label>
                <Calendar2LineIcon onClick={openDatePicker2} size={'1.5rem'} style={{ cursor: 'pointer', position: 'absolute', 'top': '36px', right: '12px', zIndex: 1 }} />
                <DatePicker
                  ref={datePickerRef2}
                  selected={toDate}
                  className="form-control center"
                  onChange={(date) => setToDate(date)}
                  dateFormat="yyyy-MM-dd"
                  name="todate"
                  showMonthDropdown
                  showYearDropdown
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                  value={toDate}
                />
              </div>

              <div className="col-lg-2 col-md-4 mb-2">
                <label>Batch/SIM/Mobile/TXN</label>
                <input
                  type="text"
                  className="form-control"
                  id="txnNumber"
                  name="txnNumber"
                  placeholder="Batch/SIM/Mobile/TXN"
                  {...registerFilter("txnNumber")}
                />
              </div>

              <div className={(isAdmin(tokenData) || isAdminAgent(tokenData)) ? 'col-lg-2 col-md-4 mb-2' : 'col-lg-2 col-md-4'}>
                <div className={(isAdmin(tokenData) || isAdminAgent(tokenData)) ? "mt-2 d-flex justify-content-start activation-search-btn" : "mt-4"}>
                  <Button title="Search" style="minWidth:80px" loading={searchButtonLoading} buttonClass={`btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC`} buttonType='submit' />
                </div>
              </div>

            </div>
          </form>
          <hr />

          {(isAdmin(tokenData) || isAdminAgent(tokenData)) && (
            <>
              <InCompletePortinCount />
              <hr />
            </>
          )}
          <div className="row mb-3  ">
            <div className='col-lg-3  activation-request-search-btn mb-sm-444'>
              <SearchBar onFilter={handleFilterChange} filterText={filterText} />
            </div>
            <div className='col-lg-9 d-flex justify-content-end activation-request-action-btn' style={{ gap: '5px' }}>
              {isDealer(tokenData) && <>
                <SideButtons title="Add Portin" onClick={handleAddPortinActivation} buttonStyle="primary" style={{ marginLeft: '8px' }} />
              </>}
              <div>
                {(isAdmin(tokenData) || isAdminAgent(tokenData) || tokenData[0]?.IsAgent == 1) && (
                  <Button title="Manual Portin Update" onClick={handleManualUpdatePortin} icon={<EditCircleLineIcon size={15} />} style="minWidth:120px" buttonClass={isAdmin(tokenData) ? `btn btn-primary mr-2 font-weight-bold text-white` : `btn btn-primary mr-2 font-weight-bold text-white`} />
                )}
              </div>
            </div>
          </div>
          <DataTable
            columns={columns}
            data={data}
            loading={bulkPortinActivationLoading}
            customStyles={{
              headRow: {
                style: {
                  backgroundColor: '#FFF5F5'
                },
              },
              headCells: {
                style: {
                  fontWeight: 'bold',
                  fontSize: "14px"
                },
              },
            }}
          />
        </div>
      }

      <Modal
        showModal={openViewModel}
        title={"Portin Details : "}
        subTitle={<span style={{ color: '#990404' }}>{selectedBatchID}</span>}
        onHide={() => closeBulkTxnModal()}
        width={1000}
        showFooter={false}
      >
        {showAlert && <div className='mt-4'><Alert type={alertType} text={alertText} closeBtn={alertCancel} /></div>}
        <div className="d-flex justify-content-between mb-3">
          <div>
            <button onClick={handleCopy} style={{ minWidth: '100px', padding: '6px 10px', backgroundColor: '#990404', color: 'white', fontWeight: 'bold', border: 'none', borderRadius: '4px', cursor: 'pointer' }} > Copy </button>
          </div>
          <div className="d-flex" style={{ gap: '8px' }}>
            {(isAdmin(tokenData) || isAdminAgent(tokenData) || tokenData[0]?.IsAgent == 1) && (
              <div className="d-flex">
              </div>
            )}
            {listDataModel && listDataModel.length > 0 && (
              <Button onClick={exportToCSVModal} title="Export" icon={<DownloadCloud2sLineIcon size={15} />} style={{ minWidth: '120px' }} buttonClass="btn acti-export-btn-v acti-ex-btn font-weight-bold text-white" />
            )}
            <button onClick={handleRefersh} style={{ minWidth: '100px', padding: '6px 10px', backgroundColor: '#990404', color: 'white', fontWeight: 'bold', border: 'none', borderRadius: '4px', cursor: 'pointer' }} > Refresh </button>
          </div>
        </div>

        <Table columns={ModalColumns} loading={bulkPortinActivationResultByBatchIDLoading} data={dataSource} pagination={false} />
      </Modal>

      <AddPortinActivation search={searchButtonData} />
      {completeModal && renderCompleteModal()}
      {cancelModal && renderCancelModal()}
      {manualUpdateFlag && renderManualPortinUpdate()}
      {refundModal && renderRefundModal()}

    </CardLayout>
  )
}

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: "white",
  padding: "30px",
  borderRadius: "10px",
  boxShadow: "0px 4px 10px rgba(0,0,0,0.25)",
  textAlign: "center",
};

const buttonStyle = {
  marginTop: "20px",
  padding: "10px 20px",
  backgroundColor: "#dc3545",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
};

export default PortinActivation;